// removed by extract-text-webpack-plugin
module.exports = {"entrance-container":"entrance-container","ant-row":"ant-row","entrance-wrapper":"entrance-wrapper","shadow-way":"shadow-way","shadow-dash":"shadow-dash","entrance-wrapper-2":"entrance-wrapper-2","shadow-box":"shadow-box","dna-icon":"dna-icon","entrance-web":"entrance-web","entrance-text":"entrance-text","pgd":"pgd","vertical-center-modal":"vertical-center-modal","ant-modal-mask":"ant-modal-mask","ant-modal-header":"ant-modal-header","ant-modal-footer":"ant-modal-footer","ant-upload":"ant-upload","ant-upload-drag":"ant-upload-drag"};


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/entrance/Index.scss
// module id = 1422
// module chunks = 0